/* Lazy-loads and plays Gerber section videos only while they are near the viewport. */
(function () {
  if (window.gerberMediaVideoInit) return;
  window.gerberMediaVideoInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  function load(video) {
    if (video.dataset.gerberLoaded) return;
    video.dataset.gerberLoaded = 'true';
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].getAttribute('data-src');
    }
    video.load();
  }

  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          load(video);
          play(video);
        } else if (video.dataset.gerberLoaded) {
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  function init() {
    var videos = document.querySelectorAll('video[data-gerber-video]');
    for (var i = 0; i < videos.length; i++) observer.observe(videos[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
